/** Single on-device fiscal-QR filter shared by native and WASM camera modes.
 * An ordinary tips/web QR must never stop scanning or reach submitPayload.
 */
export function looksLikeFiscalQr(raw: string): boolean {
  const params = new URLSearchParams(raw.trim().replace(/^\?/, ''));
  return ['t', 's', 'fn', 'i', 'fp', 'n'].every((key) => Boolean(params.get(key)));
}
